import React, { useState, useContext, useEffect } from 'react';
import { Card, Row, Col, NavDropdown, Form  } from 'react-bootstrap';
import { Button, TextField, MenuItem } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useWidgetContext } from '../context/DragContext';
import { AuthContext } from '../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import SwitchAccount from '../common/SwitchAccount';
import { showSweetAlert } from './SweetAlert';

function Trade() {
    const [amount, setAmount] = useState('');
    const [selectedButton, setSelectedButton] = useState('Shares');
    const [selectedBuySellButton, setSelectedBuySellButton] = useState('BUY');
    const [fromAccount, setFromAccount] = useState('MKT');
    const { removeWidgetFromGrid } = useWidgetContext();
    const { currentDate, currentTime, createOrder, getOrderData, userData, thirdParyAccount, symbolData, baseCurencySymbol, curencySymbol } = useContext(AuthContext);
    const [verified, setVerified] = useState(true);
    const [switchAccount, setSwitchAccount] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const isDemoPath = location.pathname === '/demo';
    const token = localStorage.getItem('accessToken');

    const handleOpenSwitchAccount = () => setSwitchAccount(true);
    const handleCloseSwitchAccount = () => setSwitchAccount(false);

    const handleAmountChange = (event) => {
        const value = parseFloat(event.target.value, 10);
    setAmount(isNaN(value) ? "" : value);
    };
    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
    };
    const handleBuySellButtonClick = (buttonName) => {
        setSelectedBuySellButton(buttonName);
    };
    const handleFromAccountChange = (event) => {
        setFromAccount(event.target.value);
    };

    const [showDropdown, setShowDropdown] = useState(false);

    const handleToggle = (isOpen) => {
        setShowDropdown(isOpen);
    };

    const handleSvgClick = () => {
        setShowDropdown(!showDropdown);
    };

    // Determine if the submit button should be disabled
    const isSubmitDisabled = !amount || !selectedButton || !selectedBuySellButton || !fromAccount;

    const handleSubmit = async () => {
        if (isSubmitDisabled) {
            return;
        }

        const orderParams = {
            quantity: selectedButton === 'Shares' ? amount : "",
            side: selectedBuySellButton,
            cashqty: selectedButton === 'Dollars' ? amount : "",
            ordertype: fromAccount
        };
    
        try {
            const response = await createOrder(
                orderParams.quantity, 
                orderParams.side, 
                orderParams.ordertype, 
                orderParams.cashqty, 
                thirdParyAccount, 
                symbolData, 
                baseCurencySymbol, 
                curencySymbol
            );
        
            console.log(response);
        
            if (response?.details?.length > 0) {
                // If details exist, check the order status
                const orderStatus = response.details[0]?.order_status;
                if (orderStatus === 'PreSubmitted' || orderStatus === 'Submitted') {
                    setVerified(false);
                    setAmount('');
                    getOrderData();
                } else {
                    // If details exist but order status is unexpected
                    showSweetAlert('Error!', `Unexpected order status: ${orderStatus}`, 'error');
                }
            } else if (response?.success === true) {
                // If details do not exist but success is true
                setVerified(false);
                setAmount('');
                getOrderData();
            } else if (response?.success === false) {
                // If success is explicitly false
                showSweetAlert('Error!', response?.error_response?.message || response?.error_response?.error_details || 'An error occurred', 'error');
            } else {
                // Catch any other unknown failure cases
                showSweetAlert('Error!', response?.error_details || "Something went wrong!", 'error');
            }
            
        } catch (error) {
            showSweetAlert('Error!', error.message || "Unexpected error occurred", 'error');
        }
        
    };

    const handleOrderSubmit = async (event) => {
        getOrderData();
    }

    const handleDemo = () => {
        if(token){
            navigate('/pricing-plans', { state: { email: userData.email, name : userData.name } });
        }
        else{
            navigate('/signup');
        }
    }

    return (
        <>
            <Card className={`main-card mt-3 ${isDemoPath || userData?.added_integrations?.length === 0 ? 'blur-card' : ''}`}>
                {(isDemoPath || userData?.added_integrations?.length === 0) && (
                    <div className="blur-overlay">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/lock-icon.svg`}
                            alt="Lock Icon"
                            style={{ height: '20px', width: '16px' }}
                            className="lock-icon"
                        />
                        {isDemoPath && <button className="subscribe-button" onClick={handleDemo}>Subscribe to access</button>}
                        {userData?.isPaymentDone && userData?.added_integrations?.length === 0 && (
                            <button className="subscribe-button" onClick={handleOpenSwitchAccount}>
                                Click to add Provider
                            </button>
                        )}
                    </div>
                )}
                <Card.Header className="pb-0">
                    <div className="d-flex justify-content-between mt-1">
                        <h2 className="medium-heading mb-0">Trade</h2>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                onClick={handleSvgClick}
                                style={{ cursor: 'pointer' }}
                            >
                                <path d="M12 13.5C11.7033 13.5 11.4133 13.412 11.1666 13.2472C10.92 13.0824 10.7277 12.8481 10.6142 12.574C10.5006 12.2999 10.4709 11.9983 10.5288 11.7074C10.5867 11.4164 10.7296 11.1491 10.9393 10.9393C11.1491 10.7296 11.4164 10.5867 11.7074 10.5288C11.9983 10.4709 12.2999 10.5006 12.574 10.6142C12.8481 10.7277 13.0824 10.92 13.2472 11.1666C13.412 11.4133 13.5 11.7033 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5Z" fill="white" />
                                <path d="M18.75 13.5C18.4533 13.5 18.1633 13.412 17.9166 13.2472C17.67 13.0824 17.4777 12.8481 17.3642 12.574C17.2506 12.2999 17.2209 11.9983 17.2788 11.7074C17.3367 11.4164 17.4796 11.1491 17.6893 10.9393C17.8991 10.7296 18.1664 10.5867 18.4574 10.5288C18.7483 10.4709 19.0499 10.5006 19.324 10.6142C19.5981 10.7277 19.8324 10.92 19.9972 11.1666C20.162 11.4133 20.25 11.7033 20.25 12C20.25 12.3978 20.092 12.7794 19.8107 13.0607C19.5294 13.342 19.1478 13.5 18.75 13.5Z" fill="white" />
                                <path d="M5.25 13.5C4.95333 13.5 4.66332 13.412 4.41665 13.2472C4.16997 13.0824 3.97771 12.8481 3.86418 12.574C3.75065 12.2999 3.72094 11.9983 3.77882 11.7074C3.8367 11.4164 3.97956 11.1491 4.18934 10.9393C4.39912 10.7296 4.66639 10.5867 4.95737 10.5288C5.24834 10.4709 5.54994 10.5006 5.82403 10.6142C6.09812 10.7277 6.33238 10.92 6.49721 11.1666C6.66203 11.4133 6.75 11.7033 6.75 12C6.75 12.3978 6.59197 12.7794 6.31066 13.0607C6.02936 13.342 5.64783 13.5 5.25 13.5Z" fill="white" />
                            </svg>
                            <NavDropdown
                                show={showDropdown}
                                onToggle={handleToggle}
                                title=""
                                id="nav-dropdown"
                                align="end"
                                className="d-inline custom-nav-dropdown"
                                style={{ display: showDropdown ? 'block' : 'none' }}
                            >
                                <NavDropdown.Item className="dropdown-option" onClick={() => removeWidgetFromGrid('trade')}>Close Window</NavDropdown.Item>
                            </NavDropdown>
                        </div>
                    </div>
                    <div className="small-gray small-gary-date">{currentDate} | {currentTime}</div>
                </Card.Header>
                <Card.Body className="pt-0 pl-0 pr-0">
                    {verified ? (
                        <form>
                            <Row className="mb-2 mt-2 control pl-1 pr-1">
                                <Col sm={6}>
                                    {/* Text Field for Amount */}
                                    <FormControl className="square-form-control m-0" sx={{ m: 1, minWidth: 120 }}>
                                        <TextField
                                            placeholder="Share amount"
                                            value={amount}
                                            onChange={handleAmountChange}
                                            fullWidth
                                            margin="normal"
                                            inputProps={{ className: 'no-arrows' }}
                                            type="number"
                                        />
                                    </FormControl>
                                </Col>
                                <Col sm={3}>
                                    <Button
                                        variant="outlined"
                                        className={`ai-btn w-100 ${selectedButton === 'Shares' ? 'active' : ''}`}
                                        onClick={() => handleButtonClick('Shares')}
                                        style={{
                                            backgroundColor: selectedButton === 'Shares' ? 'rgba(49, 124, 255, 0.20)' : 'transparent',
                                            color: selectedButton === 'Shares' ? '#FFFFFF' : '#898889'
                                        }}
                                    >
                                        Shares
                                    </Button>
                                </Col>
                                <Col sm={3}>
                                    <Button
                                        variant="outlined"
                                        className={`ai-btn w-100 ${selectedButton === 'Dollars' ? 'active' : ''}`}
                                        onClick={() => handleButtonClick('Dollars')}
                                        style={{
                                            backgroundColor: selectedButton === 'Dollars' ? 'rgba(49, 124, 255, 0.20)' : 'transparent',
                                            color: selectedButton === 'Dollars' ? '#FFFFFF' : '#898889'
                                        }}
                                    >
                                        Dollars
                                    </Button>
                                </Col>
                            </Row>

                            <Row className="mb-2 control pl-1 pr-1">
                                <Col sm={6}>
                                    <Button
                                        variant="outlined"
                                        className={`ai-btn w-100 ${selectedBuySellButton === 'BUY' ? 'active' : ''}`}
                                        onClick={() => handleBuySellButtonClick('BUY')}
                                        style={{
                                            backgroundColor: selectedBuySellButton === 'BUY' ? 'rgba(49, 124, 255, 0.20)' : 'transparent',
                                            color: selectedBuySellButton === 'BUY' ? '#FFFFFF' : '#898889'
                                        }}
                                    >
                                        BUY
                                    </Button>
                                </Col>
                                <Col sm={6}>
                                    <Button
                                        variant="outlined"
                                        className={`ai-btn w-100 ${selectedBuySellButton === 'SELL' ? 'active' : ''}`}
                                        onClick={() => handleBuySellButtonClick('SELL')}
                                        style={{
                                            backgroundColor: selectedBuySellButton === 'SELL' ? 'rgba(49, 124, 255, 0.20)' : 'transparent',
                                            color: selectedBuySellButton === 'SELL' ? '#FFFFFF' : '#898889'
                                        }}
                                    >
                                        SELL
                                    </Button>
                                </Col>
                            </Row>
                            <Row className="mb-2 pl-1 pr-1">
                                <Col sm={12}>
                                    <FormControl className="square-form-control m-0" sx={{ m: 1, minWidth: 120 }}>
                                        <Select
                                            value={fromAccount}
                                            onChange={handleFromAccountChange}
                                            displayEmpty
                                            inputProps={{ 'aria-label': 'Without label' }}
                                            className="square-select"
                                        >
                                            <MenuItem value=""> Order Type </MenuItem>
                                            <MenuItem value="MKT"> Market </MenuItem>
                                            <MenuItem value="LMT"> Limit </MenuItem>
                                            <MenuItem value="TRAILLMT"> Trail Limit </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Col>
                            </Row>

                            <div className="col-12 text-center">
                                <p className="gray-text mt-2 mb-2">View expanded ticket</p>
                            </div>
                            <div className="row pl-1 pr-1">
                            <div className="col-1"></div>
                            <div className="col-5">
                                <Button variant="contained" disabled={isSubmitDisabled} size="small" className="btn-primary multi-b-s w-100 text-capitalize" 
                                style={{
                                    color: isSubmitDisabled ? '#000000' : '#FFFFFF', // White text when disabled
                                    backgroundColor: isSubmitDisabled ? '#D3D3D3' : '#2979FF', // Disabled shade or primary color
                                    cursor: isSubmitDisabled ? 'not-allowed' : 'pointer', // Change cursor style
                                    opacity: isSubmitDisabled ? 0.6 : 1 // Adjust opacity for disabled state
                                }} onClick={handleSubmit}>Submit</Button>
                            </div>
                            <div className="col-5">
                                <Button variant="outlined" size="small" className="outlined-btn w-100">Preview</Button>
                            </div>
                            </div>
                        </form>
                    ) : (
                        <>
                            <Row className="text-center">
                                <Col sm={12}>
                                    <img 
                                    style={{ height: "100px", width: "100px"}} 
                                    src={`${process.env.PUBLIC_URL}/images/green_check.svg`} 
                                    alt="green_check" 
                                    className="mb-2" 
                                    />
                                </Col>
                                <Col sm={12}>
                                    <p style={{ fontSize: '18px', margin: '6px 0' }}>Submit successfully!</p>
                                </Col>
                            </Row>
                            <Form onSubmit={handleOrderSubmit}>
                            <div className="mb-1 row justify-content-center">
                                <Button variant="primary" type="submit" style={{ backgroundColor: '#317CFF', textTransform: 'none' }} className="mt-4 w-65 p-2 btn-primary" onClick={() => setVerified(true)}>
                                    Finish
                                </Button>
                            </div>
                            </Form>
                        </>
                    )}
                </Card.Body>
            </Card>

            <SwitchAccount open={switchAccount} onClose={handleCloseSwitchAccount}/>
        </>
    );
}

export default Trade;